import { render, staticRenderFns } from "./coLevelHelp.vue?vue&type=template&id=3b9b9ffb&scoped=true&"
import script from "./coLevelHelp.vue?vue&type=script&lang=ts&"
export * from "./coLevelHelp.vue?vue&type=script&lang=ts&"
import style0 from "./coLevelHelp.vue?vue&type=style&index=0&id=3b9b9ffb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b9ffb",
  null
  
)

export default component.exports